import useFetchLegacyInventoryStatus from '../../../core/apiHooks/useFetchLegacyInventoryStatus';
import { useAppSelector } from '../../../core/utils';
import { selectAllTransmissionsFromVehicles } from '../../../core/reducers/vehicles';
import { isTransmissionWithModelCode } from '../../../core/types/legacyInventory';
const useModelsInventoryStatus = (shouldFetch = true) => {
    const defaultTransmissions = useAppSelector(selectAllTransmissionsFromVehicles);
    // type guard to remove possible undefined elements
    const transmissions = defaultTransmissions === null || defaultTransmissions === void 0 ? void 0 : defaultTransmissions.filter(isTransmissionWithModelCode);
    const { data, isError, isFetching, isLoading } = useFetchLegacyInventoryStatus(transmissions, undefined, shouldFetch);
    return {
        data,
        isError,
        isFetching,
        isLoading,
    };
};
export default useModelsInventoryStatus;
